import { useCallback, useState, PropsWithChildren, MutableRefObject } from 'react';
import { ClickAwayListener, Grow, IconButton, Paper, Popper, MenuList } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface MoreMenuProps {
  closeRef?: MutableRefObject<(() => unknown) | undefined>;
}

export const MoreMenu = ({ closeRef, children }: PropsWithChildren<MoreMenuProps>) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();
  const open = Boolean(anchorEl);

  const handleToggle = useCallback(
    (event?: React.SyntheticEvent<HTMLElement | {}>) => {
      if (event) event.stopPropagation();

      const currentTarget = event?.currentTarget;
      setAnchorEl(currentTarget instanceof HTMLElement ? currentTarget : undefined);
    },
    [setAnchorEl],
  );
  const handleClickOutside = useCallback(
    (event: MouseEvent | TouchEvent) => {
      event.preventDefault();
      event.stopPropagation();
      setAnchorEl(undefined);
    },
    [setAnchorEl],
  );

  if (closeRef) closeRef.current = handleToggle;
  return (
    <>
      <IconButton size='large' onClick={handleToggle}>
        <MoreVertIcon />
      </IconButton>
      <Popper placement='bottom-end' open={open} anchorEl={anchorEl} transition>
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClickOutside}>
            <Grow {...TransitionProps}>
              <Paper>
                <MenuList role='menu'>{children}</MenuList>
              </Paper>
            </Grow>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
};
